import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DischargeReasonApi } from '../api/discharge-reason.api';
import { switchMap, map } from 'rxjs/operators';

import { DischargeReasonData, DischargeReason } from '../../../interfaces/masters/discharge-reason' ;
@Injectable()
export class DischargeReasonService extends DischargeReasonData {

    constructor(private api: DischargeReasonApi) {
      super();
    }
  
  
    list(url: string): Observable<DischargeReason[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<DischargeReason>{
        return this.api.getById(url);
    }
  
    create(url: string, data:DischargeReason): Observable<DischargeReason[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:DischargeReason): Observable<DischargeReason> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  